import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Themes } from '../../../services/Theme/ThemeSwitcher';
import { ThemeManagerService } from '../../../services/Theme/theme-manager.service';

@Component({
  selector: 'app-theme-menu',
  imports: [MatIconModule, MatMenuModule],
  templateUrl: './theme-menu.component.html',
  styleUrl: './theme-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeMenuComponent {
  protected readonly themeService = inject(ThemeManagerService);
  protected readonly savedTheme = this.themeService.savedThemeSignal;
  protected readonly themes = Themes.filter(
    theme => !['Template', 'CAPS', 'AltFont', 'No'].includes(theme.themeName),
  );
  protected readonly modes = [
    { name: 'Light', icon: 'light_mode' },
    { name: 'Dark', icon: 'dark_mode' },
    { name: 'System', icon: 'desktop_windows' },
  ] as const;
}
